const AddIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='currentColor'>
      <path d='M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z'></path>
    </svg>
  );
};

export default AddIcon;
